import anf from './anf.svg';
import fedex from './fedex.svg';
import hco from './hco.svg';
import kids from './kids.svg';

function makeDataUri(svg) {
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

const svgData = {
  anf: makeDataUri(anf),
  fedex: makeDataUri(fedex),
  hco: makeDataUri(hco),
  kids: makeDataUri(kids),
}

// Empty SVG data URI
const emptySvgDataUri = makeDataUri('<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0"></svg>');

export default function getSvgData(name) {
  if (name in svgData) {
    return svgData[name];
  }

  return emptySvgDataUri;
}
